import { useState } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Campaign } from 'domains/campaigns/types';
import ABTestInsightsModal from './AbTestInsightsModal/ABTestInsightsModal';
import WinnerScheduleModal from './WinnerScheduleModal/WinnerScheduleModal';
import { themeColors } from 'colors';

type PendingWinnerSelectionStatusProps = {
    campaign: Campaign;
};

const WinnerDeclaredStatus = ({ campaign }: PendingWinnerSelectionStatusProps) => {
    const [isInsightsModalOpen, setIsInsightsModalOpen] = useState(false);
    const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);

    const handleViewInsights = () => {
        setIsInsightsModalOpen(true);
    };

    const handleInsightsModalClose = () => {
        setIsInsightsModalOpen(false);
    };

    const handleSendWinner = () => {
        setIsScheduleModalOpen(true);
    };

    const handleScheduleModalClose = () => {
        setIsScheduleModalOpen(false);
    };

    // Only show send winner button for 50% split (when there's remaining audience)
    const shouldShowSendWinnerButton = campaign.abTestConfig?.testPercentage === 50;

    // Get the appropriate message based on test percentage
    const getStatusMessage = () => {
        if (campaign.abTestConfig?.testPercentage === 50) {
            return 'Review & send the winner to the remaining audience';
        }
        return 'User has declared the winner';
    };

    return (
        <>
            <ABTestInsightsModal
                campaign={campaign}
                isOpen={isInsightsModalOpen}
                handleModalClose={handleInsightsModalClose}
            />
            <WinnerScheduleModal
                campaign={campaign}
                isOpen={isScheduleModalOpen}
                handleModalClose={handleScheduleModalClose}
            />
            <Box
                sx={{
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    padding: '16px',
                }}
            >
                <Stack spacing={1}>
                    <Stack spacing={0.5}>
                        <Stack direction="row" alignItems="baseline" spacing={1.4}>
                            <Box
                                sx={{
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    backgroundColor: themeColors.success.main,
                                }}
                            />
                            <Typography>winner declared</Typography>
                        </Stack>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            {getStatusMessage()}
                        </Typography>
                    </Stack>

                    <Stack direction="row" spacing={2} justifyContent={'end'} sx={{ paddingLeft: '20px' }}>
                        <Button
                            variant="outlined"
                            onClick={handleViewInsights}
                            sx={{
                                backgroundColor: 'white',
                            }}
                        >
                            View Insights
                        </Button>
                        {shouldShowSendWinnerButton && (
                            <Button variant="contained" onClick={handleSendWinner} disabled={false}>
                                Send winner
                            </Button>
                        )}
                    </Stack>
                </Stack>
            </Box>
        </>
    );
};

export default WinnerDeclaredStatus;
